"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataURItoBlob = dataURItoBlob;
exports.getFileErrorText = void 0;

var _i18n = _interopRequireDefault(require("./i18n"));

var _ramda = require("ramda");

function dataURItoBlob(dataURI, fileName) {
  var byteString;

  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  var ia = new Uint8Array(byteString.length);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([ia], {
    type: mimeString
  });
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
}

var getFileErrorText = function getFileErrorText(error) {
  var sizeErrorregExp = /^The uploaded file exceeds the (\d*) bytes$/;
  var sizeError = (0, _ramda.test)(sizeErrorregExp, error);

  if (sizeError) {
    var bytes = sizeErrorregExp.exec(error)[1];
    var maximumSize = bytes / 1024 / 1024;
    return _i18n["default"].t('errors.maximumFileSize', {
      count: maximumSize
    });
  } else {
    return _i18n["default"].t('errors.uploadError');
  }
};

exports.getFileErrorText = getFileErrorText;